// import style from "LoadSpinning.module.css";

export default function LoadSpinning() {
  return <div>LoadSpinning</div>;
}
